const generateAddress = (addressValues: any[]) => {
  return addressValues.filter((eachAddress) => !!eachAddress).join(", ");
};

export default generateAddress;
